export default function csrfToken(): string {
  const meta = document.querySelector<HTMLMetaElement>('meta[name=csrf-token]');
  return meta ? meta.content : '';
}
